module.exports = __webpack_public_path__ + "img/pic_5.bae803b7.png";